module.exports = __webpack_public_path__ + "img/ricefield-ubud.b7bdfab6.jpeg";